<template>
  <button class="interaction-close btn-float top right"
          @click="(evt) => $emit('click', evt)">

    <i class="mdi mdi-close"></i>

  </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.interaction-close {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
